export class RoomType {
    constructor() {
        this.name = '';
        this.code = '';
        this.base_adult = 0;
        this.base_child = 0;
        this.max_adult = 0;
        this.max_child = 0;
        this.color = 'red';
        this.amenities = [];
        this.note = "";
        return this;
    }

    toViewModel(responseModal) {
        this.id = responseModal.id;
        this.name = responseModal.name;
        this.code = responseModal.code;
        this.base_adult = responseModal.base_adult;
        this.base_child = responseModal.base_child;
        this.max_adult = responseModal.max_adult;
        this.max_child = responseModal.max_child;
        this.color = responseModal.color;
        this.amenities = responseModal.amenities;
        this.note = responseModal.note;
        return this;
    }

    toRequestModel() {
        let tempRoomType = {};
        tempRoomType.name = this.name;
        tempRoomType.code = this.code;
        tempRoomType.base_adult = this.base_adult;
        tempRoomType.base_child = this.base_child;
        tempRoomType.max_adult = this.max_adult;
        tempRoomType.max_child = this.max_child;
        tempRoomType.color = this.color;
        tempRoomType.note = this.note;
        tempRoomType.amenities = this.amenities.map(a => {
            return a.id;
        });
        
        return tempRoomType;
    }
}